import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import UsersListPage from './pages/UsersListPage';
import UserDetailPage from './pages/UserDetailPage';
import UserCreatePage from './pages/UserCreatePage';

const UsersModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<UsersListPage />} />
      <Route path="/create" element={<UserCreatePage />} />
      <Route path="/:userId" element={<UserDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default UsersModule;
